import { useQuery } from '@tanstack/react-query';

import type { ExtranetMeResponse } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { extranetQueryKeys } from '../queryKeys';

export const useMe = (enabled = true) =>
  useQuery({
    queryKey: extranetQueryKeys.account.me(),
    queryFn: () => getExtranetApi().get<Record<string, never>, ExtranetMeResponse>('/v1/extranet/users/me', {}),
    enabled,
    staleTime: 60 * 1000,
  });
